// extracted by mini-css-extract-plugin
export var textInput = "_ls-0";